
  // Counts graphemes rather than UTF-16 code units so the number matches
  // Ecto's validate_length/3, which is what actually rejects the value.
  const segmenter =
    typeof Intl !== "undefined" && Intl.Segmenter
      ? new Intl.Segmenter(undefined, { granularity: "grapheme" })
      : null

  const countGraphemes = (value) =>
    segmenter ? [...segmenter.segment(value)].length : [...value].length

  export default {
    mounted() {
      this.control = this.el.querySelector("[data-textarea-control]")
      this.counter = this.el.querySelector("[data-textarea-counter]")
      this.onInput = () => this.render()
      this.control.addEventListener("input", this.onInput)
      this.render()
    },
    updated() {
      this.render()
    },
    destroyed() {
      this.control?.removeEventListener("input", this.onInput)
    },
    render() {
      if (!this.control || !this.counter) return
      const used = countGraphemes(this.control.value)
      const max = this.el.dataset.maxlength
      this.counter.textContent = max
        ? `${used} of ${max} characters`
        : `${used} characters`
    },
  }
